import React from "react";
import { PageHeader, Panel, KpiCard, KpiGrid, Table, StatusChip, useAdminQuery, RefreshButton, Unavailable, fmtDate, MUTE } from "../_shared";

export default function AdminHealth() {
  const h = useAdminQuery("/admin/health");
  return (
    <div data-testid="admin-health-page">
      <PageHeader title="System Health"
        subtitle="Live probes against production dependencies."
        right={<RefreshButton loading={h.loading} onClick={h.refresh} />} />

      {h.loading ? <Loading /> : h.error ? <Unavailable error={h.error} /> : (
        <>
          <KpiGrid>
            <KpiCard label="Pending jobs"   value={h.data?.pending_jobs}      testId="kpi-pending-jobs" />
            <KpiCard label="Failed · 30d"   value={h.data?.failed_jobs_30d}   testId="kpi-failed-jobs" />
            <KpiCard label="Deployed version" value={h.data?.deployed_version || "unknown"} testId="kpi-version" />
            <KpiCard label="Checked"        value={fmtDate(h.data?.generated_at)} testId="kpi-checked" />
          </KpiGrid>
          <Panel title="Services" testId="admin-health-services">
            <Table cols={[
              { label: "Service", render: (s) => s.service },
              { label: "Status",  render: (s) => <StatusChip status={s.status} /> },
              { label: "Detail",  render: (s) => <span style={{ color: MUTE, fontSize: 12 }}>{s.detail}</span> },
              { label: "Last check", render: (s) => fmtDate(s.last_check) },
            ]} rows={h.data?.services || []} keyFn={(s) => s.service} />
          </Panel>
        </>
      )}
    </div>
  );
}
function Loading() { return <div style={{ padding: 30, color: MUTE, fontSize: 13, textAlign: "center" }}>Loading…</div>; }
